import React from 'react';
import { ICellRendererParams } from 'ag-grid-community';

import { CheckTickFilled, CircleCrossLined } from '@tag/tag-icons';

import styles from './bulk-update-contracts-comp.module.scss';


import Spinner from '@/components/common/Spinner/Spinner';
import { ProcessingStatus } from '../utils/fileParser';

interface StatusCellRendererProps extends ICellRendererParams {
  data: {
    status?: ProcessingStatus;
  };
}

export default function StatusCellRenderer({ data }: StatusCellRendererProps) {
  const status = data?.status || 'pending';

  switch (status) {
    case 'processing':
      return (
        <div className={styles['status-cell']}>
          <Spinner />
        </div>
      );
    case 'success':
      return (
        <div className={styles['status-cell']}>
          <CheckTickFilled accent="green" size="16" />
        </div>
      );
    case 'error':
      return (
        <div className={styles['status-cell']}>
          <CircleCrossLined size="16" />
        </div>
      );
    default:
      return <div style={{ height: '100%' }} />;
  }
}
